<div class="row">
    <div class="col-6 col-lg-6 col-xl-3">
        <div class="af-form-group">
            <label class="" translate>lblAppointmentType</label>

            <div class="flexbox align-items-center">

                <div class="flexbox form-check pl-0">
                    <input type="radio" class="radio-custom m-0" id="quote" name="offertype" value="Quote"
                        disabled="true"
                        [(ngModel)]="commonService.editAppointmentService.appointmentDetails.appointmentType" />
                    <label translate class="text-dark ml-2" for="quote">
                        lblQuote
                    </label>
                </div>
                <div class="flexbox form-check ml-5">
                    <input type="radio" class="radio-custom m-0" id="order" name="offertype" disabled="true"
                        [(ngModel)]="commonService.editAppointmentService.appointmentDetails.appointmentType"
                        value="Order" />
                    <label translate class="text-dark ml-2" for="order">
                        lblOrder
                    </label>
                </div>
            </div>
        </div>
    </div>
    <div class="col-12 col-lg-6 col-xl-3">
        <div class="af-form-group">
            <label>
                <span translate>lblRegNumber</span>
            </label>
            <div class="lbl-info">
                <div class="flmid flex-wrap">
                    <div class="licplate LPNo d-flex">
                        <span class="icn-flag" [ngClass]="licensePlateClass"></span>
                        {{commonService.appointmentDetails.licensePlate}}
                    </div>
                    <div class="imgWid">
                        <ng-container>
                            <img af-brand-logo [data-code]="commonService.appointmentDetails.brandCode" data-type="BRAND"
                                class="{{commonService.appointmentDetails.brandCode}}-icon common"
                                [title]="commonService.appointmentDetails.brandCode" class="brandicon" alt="img" />
                        </ng-container>
                        <button class="btn btn-link ml-2" (click)="commonService.copyTextRegistrationNumber()"
                            placement="top" ngbTooltip="Copy Reg No." aria-label="Center Align">
                            <em class="fas fa-copy fa-lg"></em>
                        </button>
                    </div>

                </div>
            </div>
        </div>
    </div>
    <div class="col-6 col-lg-6 col-xl-3" *ngIf="commonService.contactDetails">
        <div class="af-form-group">
            <label translate>lblBookedDate</label>
            <div class="lbl-info" *ngIf="commonService.appointmentBookedDate;else load_OwnerNotFound">
                {{commonService.appointmentBookedDate | date:'short'}}
            </div>
            <ng-template #load_OwnerNotFound>
                <span></span>
            </ng-template>
        </div>
    </div>
    <div class="col-6 col-lg-6 col-xl-2">
        <div class="af-form-group">
            <label translate>lblDocumentPartStatus</label>
            <div class="lbl-info"
                *ngIf="commonService.editAppointmentService.isEdit && !commonService.editAppointmentService.appointmentDetails.isFromArchive && isDocumentPartStatusActive;else load_OwnerNotFound">
                <ng-select [(ngModel)]="commonService.SelectedDocumentPartStatus"
                    [ngModelOptions]="{standalone: true}" [disabled]="StatusDisabled"
                    placeholder="{{ 'lblSelectStatus' | translate }}"
                    (change)="commonService.onDocumentPartStatusChange()" (clear)="resetDocumetStatus()">
                    <ng-option *ngFor="let status of commonService.documentPartStatus" [value]="status.code">
                        {{status.code}}
                    </ng-option>
                </ng-select>
            </div>
            <ng-template #load_OwnerNotFound>
                <span translate>-</span>
            </ng-template>
        </div>
    </div>
    <div class="col-6 col-lg-6 col-xl-3">
        <div class="af-form-group">
            <label>
                <span translate>lblCustomer</span> / <span translate>lblOwner</span>
            </label>
            <div class="lbl-info">
                {{commonService.appointmentDetails.customerName}}
                <span
                    *ngIf="commonService.contactDetails && commonService.contactDetails.ownerName;else load_OwnerNotFound">
                    <span
                        *ngIf="commonService.appointmentDetails.customerName.toLowerCase() !== commonService.contactDetails.ownerName.toLowerCase()">
                        / {{commonService.contactDetails.ownerName}}
                    </span>
                </span>
                <ng-template #load_OwnerNotFound>
                    <span translate>/ -</span>
                </ng-template>
            </div>
        </div>
    </div>
    <div class="col-6 col-lg-6 col-xl-3">
        <div class="af-form-group">
            <label translate>lblVinNumber</label>
            <div class="lbl-info">
                {{commonService.appointmentDetails.chassisNo}}
                <button class="btn btn-link ml-2" (click)="commonService.copyTextVINNumber()" placement="top"
                    ngbTooltip="Copy VIN No." aria-label="Center Align">
                    <em class="fas fa-copy fa-lg"></em>
                </button>
            </div>
        </div>
    </div>
    <div class="col-6 col-lg-6 col-xl-3" *ngIf="commonService.contactDetails">
        <div class="af-form-group">
            <label>
                <span translate>lblAssignedMechanic</span>
            </label>
            <div class="lbl-info">
                <span class="lbl-info"
                    *ngIf="(commonService.contactDetails.plannedMechanics || commonService.contactDetails.pastPlannedMechanics) else elsePlannedMechanics">
                    <span class="text-muted">{{commonService.contactDetails.pastPlannedMechanics}}</span>
                    <span class="text-muted" *ngIf="commonService.contactDetails.pastPlannedMechanics && commonService.contactDetails.plannedMechanics">, </span>
                    <span class="font-weight-bold">{{commonService.contactDetails.plannedMechanics}}</span>
                </span>
                <ng-template #elsePlannedMechanics>
                    <span class="lbl-info" translate>lblNotYetAssigned</span>
                </ng-template>
            </div>
        </div>
    </div>
    <div class="col-6 col-lg-6 col-xl-2">
        <div class="af-form-group">
            <label translate>lblChangeStatus</label>
            <div class="lbl-info"
                *ngIf="commonService.editAppointmentService.isEdit && !commonService.editAppointmentService.appointmentDetails.isFromArchive;else load_OwnerNotFound">
                <ng-select [(ngModel)]="SelectedStatus" [ngModelOptions]="{standalone: true}"
                    [disabled]="StatusDisabled" placeholder="{{ 'lblSelectStatus' | translate }}"
                    (change)="onStatusChange()" (clear)="resetCalculations()">
                    <ng-option *ngFor="let status of commonService.statusList" [value]="status.id">
                        {{status.name}}
                    </ng-option>
                </ng-select>
                <ng-template #load_OwnerNotFound>
                    <span translate>-</span>
                </ng-template>
            </div>
        </div>
    </div>
    <div class="col-6 col-lg-3" *ngIf="commonService.contactDetails">
        <div class="af-form-group" style="max-width: 65%;">
            <label translate>lblContactName</label>
            <div class="lbl-nfo">
                <input type="text" class="form-control"
                    [disabled]="!commonService.editAppointmentService.isEdit || commonService.editAppointmentService.appointmentDetails.isFromArchive"
                    [(ngModel)]="commonService.contactDetails.contactInfo" />
            </div>
        </div>
    </div>
    <div class="col-6 col-lg-6 col-xl-3" *ngIf="commonService.contactDetails">
        <div class="af-form-group">
            <label translate>lblCampaignService</label>
            <div class="custom-control custom-switch mt-0">
                <input type="checkbox" class="custom-control-input" id="isCampaignService"
                    (change)="onChangeCampaignService($event)" [disabled]="commonService.campaignService"
                    [checked]="commonService.contactDetails.campaignService">
                <label class="custom-control-label" for="isCampaignService" translate></label>
            </div>
        </div>
    </div>
    <div class="col-3" *ngIf="commonService.contactDetails"
        [ngClass]="commonService.contactDetails && !commonService.contactDetails.isCustomerWaiting && !commonService.contactDetails?.isPickUpDropOffService ?  '' : 'disable'">
        <div class="af-form-group" style="max-width: 85%;">
            <label translate>lblCustomerDropTime</label>
            <div class="lbl-info">
                <ng-select #select [ngModelOptions]="{standalone: true}"
                    placeholder="{{ 'lblSelectCustomerDropTime' | translate }}"
                    (change)="onCustomerDropTimeSelected($event)"
                    [(ngModel)]="commonService.contactDetails.isKeyDrop"
                    [disabled]="!commonService.editAppointmentService.isEdit || isWorkOrderHistory || commonService.editAppointmentService.appointmentDetails.isFromArchive">
                    <ng-option *ngFor="let item of CustomerDropTimeDropDownValues" [value]="item.value">
                        {{item.name | translate}}
                    </ng-option>
                </ng-select>
            </div>
            <ng-template #load_elseCustomerDropTime>
                <p translate class="lbl-info">-</p>
            </ng-template>
        </div>
    </div>
    <div class="col-6 col-lg-6 col-xl-2" *ngIf="commonService.contactDetails">
        <div class="af-form-group">
            <label translate>lblParkingNote</label>
            <div class="lbl-nfo">
                <input type="text" class="form-control"
                    [disabled]="!commonService.editAppointmentService.isEdit || commonService.editAppointmentService.appointmentDetails.isFromArchive"
                    [(ngModel)]="commonService.contactDetails.parkingNote" maxlength="50" />
            </div>
        </div>
    </div>
    <div class="col-6 col-lg-3" *ngIf="commonService.contactDetails">
        <div class="af-form-group" style="max-width: 65%;">
            <label translate>lblContactMobile</label>
            <div class="lbl-nfo">
                <ngx-intl-tel-input [selectFirstCountry]= "false" 
                [disabled]="!commonService.editAppointmentService.isEdit || commonService.editAppointmentService.appointmentDetails.isFromArchive"
                [(ngModel)]="commonService.singlePhoneNo"
                [selectedCountryISO]="selectedCountryISO" [maxLength]="15" [phoneValidation]="false"
                [separateDialCode]="true" [onlyCountries]="onlyCountries" [enablePlaceholder]="false"
                (countryChange)="onNomineeCountryChange($event)" (ngModelChange)="mobileNumberChanged()">
                </ngx-intl-tel-input>
            </div>
        </div>
    </div>
    <div class="col-6 col-lg-6 col-xl-3">
        <div class="af-form-group">
            <label translate>lblModel</label>
            <div class="lbl-info">
                {{commonService.appointmentDetails.modelName}}
            </div>
        </div>
    </div>
    <div class="col-6 col-lg-6 col-xl-3">
        <div class="af-form-group">
            <label translate>lblDeliveryTime</label>
            <div class="lbl-info">
                <div class="d-flex align-items-center">
                    <div class="lbl-info date mr-3">
                        <input class="form-control datePicker width100force" appAfDatepicker
                            [ngModelOptions]="{standalone: true}" [dateTime]="false"
                            [(ngModel)]="commonService.DeliveryDate" [disableNextMonthDates]="true"
                            [defaultTime]="DefaultStartTime" [isOnlyTime]="false"
                            (ngModelChange)="onChangeDeliveryDate($event)"
                            [disabled]="!commonService.editAppointmentService.isEdit || isWorkOrderHistory || commonService.editAppointmentService.appointmentDetails.isFromArchive || commonService.appointmentBookedDate===null">
                        <em class="fas fa-calendar-alt fa-lg cursordisable"></em>
                    </div>
                    <div class="date">
                        <ngb-timepicker [(ngModel)]="commonService.deliveryTimeSlot"
                            [ngModelOptions]="{standalone: true}"
                            (ngModelChange)="onChangeDeliveryTime($event)"></ngb-timepicker>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="col-6 col-lg-6 col-xl-2">
        <div>
            <label>Check In Status</label>
            <ng-container>
                <div
                    *ngIf="commonService.contactDetails?.isCheckInDoneByCustomer === true  && commonService.contactDetails.workorderStatusId !=12">
                    <em class="fas fa-check fa-lg"></em>
                    <label class="form-check-label" style="margin-top:5px" translate>lblCheckInCompleted</label>
                </div>
                <div *ngIf="commonService.contactDetails?.isCheckInDoneByCustomer === false">
                    <em class="fas fa-times text-danger fa-lg cursordisable"></em>
                    <label class="form-check-label" style="margin-top:5px" translate>lblCheckInCompleted</label>
                </div>
                <div class="d-flex">
                    <div *ngIf="commonService.isShowGenerateAndSendCheckInButton">
                        <button class="btn btn-link  btn-lg" (click)="generateAndSendCheckinLink()" placement="top"
                            ngbTooltip="{{ 'lblGenerateAndSMSCheckInLink' | translate }}" aria-label="Center Align">
                            <em class="icon-tracker-mail font26"></em>
                        </button>
                    </div>
                    <span class="ico-div"></span>
                    <div *ngIf="commonService.isShowGenerateTrackerButton" class="ml-2">
                        <button class="btn btn-link  btn-lg" (click)="generateTrackerLink()" placement="top"
                            ngbTooltip="{{ 'lblGenerateTrackerLink' | translate }}" aria-label="Center Align">
                            <em class="icon-tracker font26"></em>
                        </button>
                        <button class="btn btn-link ml-2 btn-lg" (click)="generateAndSendTrackerLink()" placement="top"
                            ngbTooltip="{{ 'lblGenerateAndSMSTrackerLink' | translate }}" aria-label="Center Align">
                            <em class="icon-tracker-mail font26"></em>
                        </button>
                    </div>
                </div>
            </ng-container>
        </div>
        <div style="margin-top: 10px; margin-bottom: 10px;" *ngIf="isShareBoxEnabled && (editAppointmentService.appointmentDetails.isKeyDrop || editAppointmentService.appointmentDetails.isAutoKey)">
            <label translate>lblShareboxStatus</label> <span *ngIf="editAppointmentService.appointmentDetails.sentShareboxInfo"><img src="../../../../../../assets/images/sharebox0.png" width="25" style="margin-left: 1rem; margin-bottom: 2px;"/></span>
            <ng-container>
                <div *ngIf="editAppointmentService.appointmentDetails.sentShareboxInfo && (editAppointmentService.appointmentDetails.isKeyDrop || editAppointmentService.appointmentDetails.isAutoKey)">
                    <em class="fas fa-check fa-lg"></em>
                    <label class="form-check-label" style="margin-top:5px" translate>lblShareboxInfoSent</label>
                </div>
                <div
                    *ngIf="!editAppointmentService.appointmentDetails.sentShareboxInfo && (editAppointmentService.appointmentDetails.isKeyDrop || editAppointmentService.appointmentDetails.isAutoKey)">
                    <em class="fas fa-times text-danger fa-lg cursordisable"></em>
                    <label class="form-check-label" style="margin-top:5px" translate>lblShareboxInfoNotSent</label>
                </div>
            </ng-container>
        </div>
    </div>
    <div class="col-6 col-lg-6 col-xl-3" *ngIf="commonService.contactDetails">
        <div class="af-form-group" style="max-width:65%;">
            <label translate>lblSellToCustomerMobileNo</label>
            <div class="lbl-nfo">
                <ngx-intl-tel-input [selectFirstCountry]= "false" disabled
                [selectedCountryISO]="selectedCountryISO" [maxLength]="11" [phoneValidation]="false" 
                [separateDialCode]="true" [onlyCountries]="onlyCountries" [enablePlaceholder]="false"
                [(ngModel)]="commonService.mobileNo">
                </ngx-intl-tel-input>
            </div>
        </div>
    </div>

    <div class="col-6 col-lg-6 col-xl-3" *ngIf="commonService.contactDetails">
        <div class="af-form-group">
            <label translate>lbl1stRegistrationDate</label>
            <div class="lbl-info">
                {{commonService.contactDetails.registrationDate}}
            </div>
        </div>
    </div>

    <div class="col-6 col-lg-3" *ngIf="commonService.contactDetails"
        [ngClass]="commonService.contactDetails && !commonService.contactDetails.isCustomerWaiting  && !commonService.contactDetails?.isPickUpDropOffService ?  '' : 'disable'">
        <div class="af-form-group" style="max-width: 85%;">
            <label translate>lblCustomerPickUpTime</label>
            <div class="lbl-info">
                <ng-select #select [ngModelOptions]="{standalone: true}"
                    placeholder="{{ 'lblSelectCustomerPickUpTime' | translate }}"
                    (change)="onCustomerPickUpTimeSelected($event)"
                    [(ngModel)]="commonService.contactDetails.isAutoKey"
                    [disabled]="!commonService.editAppointmentService.isEdit || isWorkOrderHistory || commonService.editAppointmentService.appointmentDetails.isFromArchive">
                    <ng-option *ngFor="let item of CustomerPickUpTimeDropDownValues" [value]="item.value">
                        {{item.name | translate}}
                    </ng-option>
                </ng-select>
            </div>
            <ng-template #load_elseCustomerPickUpTime>
                <p translate class="lbl-info">-</p>
            </ng-template>
        </div>
    </div>

    <div class="col-6 col-lg-6 col-xl-3" *ngIf="commonService.contactDetails">
        <label>Need Attention</label>
        <ng-container>
            <div>
                <em class="fa fa-exclamation-triangle text-warning fa-lg"
                    *ngIf="commonService.contactDetails.needAttention === 1"></em>
                <em class="fas fa-times text-danger fa-lg cursordisable"
                    *ngIf="commonService.contactDetails.needAttention === 0"></em>
                <label class="form-check-label"
                    *ngIf="commonService.contactDetails.needAttention === 0 || commonService.contactDetails.needAttention === 1"
                    translate>lblNeedAttention</label>
                <em class="fas fa-check fa-lg" *ngIf="commonService.contactDetails.needAttention === 2">
                    <label class="form-check-label" translate>lblResolved</label>
                </em>
                <button class="btn btn-primary mr-sm-2 ml-3 btn-sm"
                    *ngIf="commonService.contactDetails.needAttention === 1" (click)="UpdateNeedAttention()"
                    translate aria-label="Center Align">lblResolve
                </button>
            </div>
        </ng-container>

        <ng-container *ngIf="commonService.IsonHoldStatus">
            <div>
                <em class="fas fa-check fa-lg" *ngIf="commonService.contactDetails.isCarRemainInWorkshop"></em>
                <em class="fas fa-times text-danger fa-lg"
                    *ngIf="commonService.contactDetails.isCarRemainInWorkshop === false"></em>
                <label class="form-check-label" style="margin-top:5px" translate>lblCarWillRemainInWorkshop</label>
            </div>
        </ng-container>
    </div>
    <div class="col-6 col-lg-3" *ngIf="commonService.contactDetails">
        <div class="af-form-group" style="max-width: 65%;">
            <label translate>lblInformation</label>
            <div class="lbl-nfo">
                <input type="text" class="form-control" maxlength="70"
                    [disabled]="!commonService.editAppointmentService.isEdit || commonService.editAppointmentService.appointmentDetails.isFromArchive"
                    [(ngModel)]="commonService.contactDetails.information" />
            </div>
        </div>
    </div>

    <div class="col-6 col-lg-6 col-xl-3" *ngIf="commonService.contactDetails">
        <div class="af-form-group">
            <label translate>lblMileage</label>
            <div class="lbl-info">
                <div class="d-flex align-items-center">
                    <div class="lbl-info relative km-block">
                        <input type="text" class="form-control kminput text-right"
                            [value]="commonService.contactDetails.kilometer"
                            [disabled]="!commonService.editAppointmentService.isEdit || isWorkOrderHistory || commonService.editAppointmentService.appointmentDetails.isFromArchive"
                            [(ngModel)]="commonService.contactDetails.kilometer" min="0" required maxlength="9"
                            [ngClass]="(+commonService.contactDetails.kilometer) === (+commonService.contactDetails.previousKilometer) ? 'bg-danger' : '' " />
                        <span class="mil-km">KM</span>
                    </div>
                    <div *ngIf ="commonService.contactDetails?.mileageUpdateBy || commonService.contactDetails?.mileageUpdateDate" class="af-form-group mileage pl-2">
                        {{commonService.contactDetails.mileageUpdateBy}} <br/>
                        {{commonService.contactDetails.mileageUpdateDate}}
                </div>
                </div>
            </div>
        </div>
    </div>

    <div class="col-6 col-lg-6 col-xl-3">
        <div class="af-form-group">
            <label translate>lblFinishedTime</label>
            <div class="lbl-info">
                <div class="d-flex align-items-center">
                    <div class="lbl-info date mr-3">
                        <input class="form-control datePicker width100force" appAfDatepicker
                            [ngModelOptions]="{standalone: true}" [dateTime]="false"
                            [(ngModel)]="commonService.FinnishedDate" [disableNextMonthDates]="true"
                            [defaultTime]="DefaultEndTime" [isOnlyTime]="false"
                            (ngModelChange)="onChangeFinnishedDate($event)"
                            [disabled]="!commonService.editAppointmentService.isEdit || isWorkOrderHistory || commonService.editAppointmentService.appointmentDetails.isFromArchive || commonService.DeliveryHour > 23 || commonService.DeliveryMinutes >=60 || commonService.appointmentBookedDate===null">
                        <em class="fas fa-calendar-alt fa-lg cursordisable"></em>
                    </div>
                    <div class="date">
                        <ngb-timepicker [(ngModel)]="commonService.finishTimeSlot"
                            [ngModelOptions]="{standalone: true}"
                            (ngModelChange)="onChangeFinnishedTime($event)"></ngb-timepicker>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="col-6 col-lg-6 col-xl-3" *ngIf="commonService.contactDetails">
        <div class="d-flex">
            <div class="form-check pl-0 ">
                <ng-container *ngIf="commonService.isRentalService">
                    <input type="checkbox" id="rentalCar"
                        [(ngModel)]="commonService.contactDetails.isRentalCarSelected"
                        (ngModelChange)="onSelectRentalCarCheckBox(false)"
                        [disabled]="!commonService.editAppointmentService.isEdit || isWorkOrderHistory || commonService.contactDetails.isCustomerWaiting || commonService.editAppointmentService.appointmentDetails.isFromArchive || !commonService.appointmentDetails.enableRentalCar">
                </ng-container>
                <ng-container
                    *ngIf="(commonService.contactDetails.rentalVehicleId && commonService.contactDetails.rentalVehicleId!=='0' )|| commonService.isRentalService">
                    <label class="form-check-label" translate>lblAvailRentalCar</label>
                </ng-container>
            </div>
            <div class="lbl-info ml-3">
                <div
                *ngIf="((commonService.contactDetails.rentalVehicleId && (commonService.contactDetails.rentalVehicleId!=='0')) || commonService.isRentalService ) && commonService.contactDetails.rentalVehicleId !== '-1' &&  commonService.contactDetails.rentalVehicleId!==null && commonService.contactDetails.isRentalCarSelected">
                <span
                    *ngIf="((commonService.contactDetails.rentalVehicleId && commonService.contactDetails.rentalVehicleId!=='0') || commonService.isRentalService);else load_elseVehicle">
                    {{ commonService.contactDetails.rentalCompanyMakeName }} -
                    <span *ngIf="!commonService.genericRentalCar">
                        {{ commonService.contactDetails.price | number:'1.2-2' }}
                    </span>
                    <span *ngIf="commonService.genericRentalCar">
                        {{ commonService.contactDetails.priceForDisply }}
                    </span>
                </span>
                <ng-template #load_elseVehicle>
                    -
                </ng-template>
            </div>
            <div
                *ngIf="(commonService.contactDetails.typeId > 0 || commonService.isRentalService || commonService.isRentalService) && commonService.contactDetails.rentalVehicleId === '-1' && commonService.contactDetails.isRentalCarSelected">
                {{ commonService.contactDetails.type }} -
                {{ commonService.contactDetails.rentalPrice }}
            </div>
            <div
            *ngIf="(commonService.contactDetails.typeId > 0 || commonService.contactDetails.type?.length > 0) && commonService.contactDetails.isRentalCarSelected && commonService.contactDetails.rentalVehicleId === null">
            {{ commonService.contactDetails.type }} -
            {{ commonService.contactDetails.rentalPrice }}
           </div>


            </div>
            <ng-template #SelectRentalCarContent let-modal>
                <div class="modal-header">
                    <h2 class="modal-title" translate>lblSelectRentalCar</h2>
                    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss(false)">
                        <span aria-hidden="true">×</span>
                    </button>
                </div>
                <div class="modal-body p-0 ">
                    <div class="popup-vcenter ">
                        <div class="flgrow">
                            <ng-container>
                                <div class="">
                                    <div class=" table-responsive">
                                        <table class="tablest1" *ngIf="!commonService.genericRentalCar">
                                            <thead>
                                                <tr>
                                                    <th id="Brand" scope="col" translate>lblBrand</th>
                                                    <th id="LicencePlate" scope="col" translate>lblRegNumber</th>
                                                    <th id="Model" scope="col" translate>lblModel</th>
                                                    <th id="Price" scope="col" translate>lblPrice</th>
                                                    <th id="Actions" scope="col" style="width:75px"
                                                        class="text-center" translate>
                                                        lblAction</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <ng-container
                                                    *ngIf="commonService.availRentalCarList?.length > 0; else load_NotFound_Search">
                                                    <tr
                                                        *ngFor="let car of commonService.availRentalCarList; let i=index"
                                                        [ngStyle]="{'color': car.notAvailable ? 'gray' : ''}">
                                                        <td>
                                                            {{car.makeName}}
                                                        </td>
                                                        <td>
                                                            {{car.licensePlate}}
                                                        </td>
                                                        <td>
                                                            {{car.model}}
                                                        </td>
                                                        <td>
                                                            {{car.price}}
                                                        </td>
                                                        <td class="text-center" style="width:100px">
                                                            <input name="Search" type="radio"
                                                                [(ngModel)]="selectedRentalCarId"
                                                                [value]="car.vehicleId"
                                                                [disabled]="car.notAvailable" />
                                                        </td>
                                                    </tr>
                                                </ng-container>
                                                <ng-template #load_NotFound_Search>
                                                    <tr>
                                                        <td colspan="8" class="no-record" translate>
                                                            lblNoRecordsFound</td>
                                                    </tr>
                                                </ng-template>
                                            </tbody>
                                        </table>
                                        <table class="tablest1" *ngIf="commonService.genericRentalCar">
                                            <thead>
                                                <tr>
                                                    <th id="brand" translate>lblType</th>
                                                    <th id="price" translate>lblPrice</th>
                                                    <th id="Actions" scope="col" style="width:75px"
                                                        class="text-center" translate>
                                                        lblAction</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <ng-container
                                                    *ngIf="commonService.genericRentalCarList?.length>0; else load_NotFound_Search">
                                                    <tr
                                                        *ngFor="let car of commonService.genericRentalCarList; let i=index">
                                                        <td>
                                                            {{car.type}}
                                                        </td>
                                                        <td>
                                                            {{car.price}}
                                                        </td>
                                                        <td class="text-center" style="width:100px">
                                                            <input name="Search" type="radio"
                                                                [(ngModel)]="selectedGenericRentalCarId"
                                                                [value]="car.typeId" />
                                                        </td>
                                                    </tr>
                                                </ng-container>
                                                <ng-template #load_NotFound_Search>
                                                    <tr>
                                                        <td colspan="3" class="no-record" translate>
                                                            lblNoRecordsFound</td>
                                                    </tr>
                                                </ng-template>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </ng-container>
                        </div>
                    </div>
                </div>

                <div class="modal-footer">
                    <button type="submit" [disabled]="!selectedRentalCarId && !selectedGenericRentalCarId"
                        class="btn btn-primary mr-sm-2" (click)="onRentalCarSelected();modal.dismiss(false)"
                        translate aria-label="Center Align">lblSelect</button>
                    <button (click)="modal.dismiss(false)" class="btn btn-secondary" aria-label="Center Align"
                        translate>lblCancel</button>
                </div>
            </ng-template>
        </div>
        <ng-container *ngIf="commonService.isRentalService || commonService.genericRentalCar">
            <button type="submit"
                [disabled]="!commonService.contactDetails.isRentalCarSelected || !commonService.editAppointmentService.isEdit || isWorkOrderHistory || commonService.contactDetails.isCustomerWaiting || commonService.editAppointmentService.appointmentDetails.isFromArchive || !commonService.appointmentDetails.enableRentalCar || commonService.appointmentDetails.rentalProvider === 2"
                (click)="OpenRentalCarListPopup(SelectRentalCarContent)" class="btn btn-primary mr-sm-2" translate
                aria-label="Center Align">lblSelectCar</button>
        </ng-container>
    </div>

    <div class="col-6 col-lg-6 col-xl-3" [hidden]="true">
        <div class="af-form-group">
            <label>
                <span translate>lblSalesPerson</span>
            </label>
            <div class="lbl-info">
                <ng-select [(ngModel)]="commonService.SelectedSalesPerson" [ngModelOptions]="{standalone: true}"
                    [disabled]="StatusDisabled" placeholder="{{ 'lblSelectSalesPerson' | translate }}"
                    (change)="commonService.onSalesPersonChange()" (clear)="commonService.resetSalesPersonList()">
                    <ng-option *ngFor="let item of salesPersonList" [value]="item.id">
                        [{{item.code}}] {{item.name}}
                    </ng-option>
                </ng-select>
            </div>
        </div>
    </div>
    <div class="col-6 col-lg-6 col-xl-3" *ngIf="commonService.contactDetails">
        <div class="form-check pl-0">
            <input type="checkbox" id="isImportedCar" [(ngModel)]="commonService.contactDetails.importedCar"
                (ngModelChange)="onChangeImportedCar($event)"
                [disabled]="!commonService.editAppointmentService.isEdit || isWorkOrderHistory || commonService.editAppointmentService.appointmentDetails.isFromArchive" />
            <label class="form-check-label" translate>lblImportedCar</label>
        </div>
    </div>
    <div class="col-6 col-lg-6 col-xl-3">
        <div class="af-form-group">
            <label>
                <span translate>lblEUControl</span>
            </label>
            <div class="lbl-info" *ngIf="commonService.appointmentPKKDate else EUDate">
                <span [ngClass]="DateClass">{{ commonService.appointmentPKKDate }}</span>
            </div>
            <ng-template class="lbl-info" #EUDate>
                -
            </ng-template>
        </div>
    </div>
    <div class="col-6 col-lg-6 col-xl-3" *ngIf="commonService.contactDetails"
        [ngClass]="commonService.contactDetails.isPickUpDropOffService ?  'disable' : '' ">
        <div class="form-check pl-0">
            <input type="checkbox" id="isCustomerWaiting"
                [(ngModel)]="commonService.contactDetails.isCustomerWaiting"
                (ngModelChange)="onSelectCustomerWaitingCheckBox()"
                [disabled]="!commonService.editAppointmentService.isEdit || isWorkOrderHistory || commonService.editAppointmentService.appointmentDetails.isFromArchive" />
            <label class="form-check-label" translate>lblCustomerWaiting</label>
        </div>
    </div>
    <div class="col-6 col-lg-6 col-xl-3" *ngIf="commonService.contactDetails">
        <div class="form-check pl-0">
            <input type="checkbox" id="isToweinCars" [(ngModel)]="commonService.contactDetails.toweinCars"
                (ngModelChange)="onChangeToweinCar($event)"
                [disabled]="!commonService.editAppointmentService.isEdit || isWorkOrderHistory || commonService.editAppointmentService.appointmentDetails.isFromArchive" />
            <label class="form-check-label" translate>lblToweinCars</label>
        </div>
    </div>
    <div class="col-6 col-lg-6 col-xl-3" *ngIf="commonService.contactDetails">
        <div class="form-check pl-0">
            <input type="checkbox" id="customerServiceAgreement" [(ngModel)]="commonService.contactDetails.customerServiceAgreement" disabled />
            <label class="form-check-label" translate>lblCustomerServiceAgreement</label>
        </div>
    </div>
    <div class="col-6 col-lg-6 col-xl-3" *ngIf="commonService.contactDetails">
        <div class="form-check pl-0">
            <input type="checkbox" id="isTireHotel" [(ngModel)]="commonService.contactDetails.isTireHotel" disabled />
            <label class="form-check-label" translate>lblTireHotel</label>
        </div>
    </div>
    <div class="col-6 col-lg-6 col-xl-3" *ngIf="commonService.contactDetails">
        <div class="form-check pl-0">
            <input type="checkbox" id="isMaintenance" [(ngModel)]="commonService.contactDetails.isMaintenance" disabled />
            <label class="form-check-label" translate>lblMaintenance</label>
        </div>
    </div>
    <div class="col-6 col-lg-6 col-xl-3" *ngIf="commonService.contactDetails">
        <div class="af-form-group" style="max-width: 65%;">
            <label translate>lblInvoiceReference</label>
            <div class="lbl-nfo">
                <input type="text" class="form-control" maxlength="35"
                    [disabled]="!commonService.editAppointmentService.isEdit || commonService.editAppointmentService.appointmentDetails.isFromArchive"
                    [(ngModel)]="commonService.contactDetails.invoiceReference" />
            </div>
        </div>
    </div>
    <div class="col-6 col-lg-6 col-xl-3"></div>
    <div class="col-6 col-lg-6 col-xl-3"></div>
</div>
    